import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { fetchUsersList, changeTheRoute } from '../../actions';
import classNames from 'classnames';
import PendingUsers from './PendingUsers'


// Later on we can use a 3rd party lib for grids and tables, like:
// http://adazzle.github.io/react-data-grid/

const UsersListView = ({onFetching, status, data, onAddUserClicked, isAccountAdmin, pendingUser}) => {

    var addUserInfoBox;
    if (isAccountAdmin) {
        addUserInfoBox = <span id="userListCreateUserLabel">Create user and assign privileges</span>;
    } else {
        addUserInfoBox = <div className="alert alert-info" role="alert"> You need to be an admin to be able to create users, please refer to <a href="https://www.ctl.io/knowledge-base/accounts-&-users/user-permissions/" target="_blank">this article</a> for more information.</div>;
            //<span>You need to be an admin to be able to create users, please refer to tho following documnet for more information: https://www.ctl.io/knowledge-base/accounts-&-users/user-permissions/</span>;
    }

    if ( status === 'init' ) {
        console.log("Refreshing list")
        onFetching()
    }
    if ( data ) {
        return (
            <div className="new-list-view-responsive new-list-view-responsive-md">
                <div className="region">
                    <div className="new-list-view-toolbar">
                        <button onClick={ ( ) => { onAddUserClicked( '/AddUser',  'push') }} type="button" className="btn btn-primary btn-lg" disabled={!isAccountAdmin}>
                            <svg className="cyclops-icon" aria-hidden="true"><use xlinkHref='#icon-plus-circle' /></svg> Create User
                        </button>
                        {addUserInfoBox}
                    </div>
                </div>

                <div>
                    <div className="new-list-view-header">
                        <h3 className="col col-35">User Name</h3>
                        <h3 className="col col-35">Permissions</h3>
                    </div>
                    <ul className="new-list-view">
                        <PendingUsers pendingUser={pendingUser}/>
                        {
                            data.map(function (item, key) {
                                return (
                                    <li>
                                        <div className="list-view-item">
                                            <div title={item.email} className="col col-35">{item.username}</div>
                                            <div className="col col-35">{item.role}</div>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        )
    } else {
        return <h1>Loading . . .</h1>
    }

};



const mapStateToProps = ( state ) => ({
    status: state.fetchUsersListRed.status,
    isFetching: state.fetchUsersListRed.isFetching,
    showLoading: state.fetchUsersListRed.showLoading,
    loadingMessage: state.fetchUsersListRed.loadingMessage,
    loadingMessage2: state.fetchUsersListRed.loadingMessage2,
    rootAccountAlias: state.fetchUsersListRed.rootAccountAlias,
    bearerToken: state.fetchUsersListRed.bearerToken,
    isAccountAdmin: state.fetchUsersListRed.isAccountAdmin,
    data: state.fetchUsersListRed.data,
    hasFailed: state.fetchUsersListRed.hasFailed,
    pendingUser: state.fetchUsersListRed.pendingUser
});


const mapDispatchToProps = ( dispatch ) => ({
    onFetching: ( status ) => {
        dispatch( fetchUsersList( status ) )
    },
    onAddUserClicked: ( newRoute, method ) => {
        dispatch: ( changeTheRoute ( newRoute, method ) )
    }
});


const UsersList = connect(
    mapStateToProps,
    mapDispatchToProps
) ( UsersListView );


export default UsersList;


/** WEBPACK FOOTER **
 ** ./src/components/User/UsersList.js
 **/